module.exports = __webpack_public_path__ + "static/media/ogomez2-card.9fd32c5d.jpg";